import { Paper, Typography } from "@mui/material";
import { MetaDrivenTable, PaginationControls } from "../../../shared/components";
import { formatCurrency } from "../../../shared/utils";

const headers = [
    { "alias_name": "project", "label": "Project", "display_order": 1, is_show: true },
    { "alias_name": "previous_eac", "label": "Previous EAC", "display_order": 2, is_show: true },
    { "alias_name": "current_eac", "label": "Current EAC", "display_order": 3, is_show: true },
    { "alias_name": "movement", "label": "Movement", "display_order": 4, is_show: true },
    { "alias_name": "movement_percentage", "label": "Movement %", "display_order": 5, is_show: true },
    { "alias_name": "direction", "label": "Direction", "display_order": 6, is_show: true },
    { "alias_name": "variations", "label": "Variations", "display_order": 7, is_show: true },
    { "alias_name": "status", "label": "Status", "display_order": 8, is_show: true },
];

const mockData = [
    {
        project: "Data Center Expansion",
        previous_eac: "6664000",
        current_eac: "6800000",
        movement: "136000",
        movement_percentage: "2.0%",
        direction: "Increasing",
        variations: "300000",
        status: "Approved",
    },
    {
        project: "Infrastructure Upgrade Phase 1",
        previous_eac: "5145000",
        current_eac: "5250000",
        movement: "105000",
        movement_percentage: "2.0%",
        direction: "Increasing",
        variations: "250000",
        status: "Approved",
    },
    {
        project: "Green Energy Initiative",
        previous_eac: "4067000",
        current_eac: "4150000",
        movement: "83000",
        movement_percentage: "2.0%",
        direction: "Increasing",
        variations: "-50000",
        status: "Approved",
    },
    {
        project: "Transport Network Upgrade",
        previous_eac: "3871000",
        current_eac: "3950000",
        movement: "79000",
        movement_percentage: "2.0%",
        direction: "Increasing",
        variations: "50000",
        status: "Pending",
    },
    {
        project: "Digital Transformation",
        previous_eac: "3381000",
        current_eac: "3450000",
        movement: "69000",
        movement_percentage: "2.0%",
        direction: "Increasing",
        variations: "50000",
        status: "Pending",
    },
    {
        project: "Facilities Modernization",
        previous_eac: "2695000",
        current_eac: "2750000",
        movement: "55000",
        movement_percentage: "2.0%",
        direction: "Increasing",
        variations: "-50000",
        status: "Approved",
    },
    {
        project: "Office Reconfiguration",
        previous_eac: "1813000",
        current_eac: "1850000",
        movement: "37000",
        movement_percentage: "2.0%",
        direction: "Increasing",
        variations: "30000",
        status: "Approved",
    },
];

const metrics = {
    previous_eac: {
        type: 'component',
        element: ((row: { previous_eac: string }) => {
            return formatCurrency(Number(row.previous_eac))
        })
    },
    current_eac: {
        type: 'component',
        element: ((row: { current_eac: string }) => {
            return formatCurrency(Number(row.current_eac))
        })
    },
    movement: {
        type: 'component',
        element: ((row: { movement: string }) => {
            return formatCurrency(Number(row.movement))
        })
    },
    variations: {
        type: 'component',
        element: ((row: { variations: string }) => {
            return formatCurrency(Number(row.variations))
        })
    }
}

export const ProjectForecastMovements = () => {
    return (
        <Paper variant="outlined" sx={{ m: 2, py: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" sx={{ px: 2 }}>
                Project Forecast Movements
            </Typography>
            <MetaDrivenTable
                headers={headers}
                data={mockData}
                dataMetrics={metrics}
                sortDisabled
            />
            <PaginationControls
                total={0}
                rowsPerPage={0}
                currentPage={0}
                handleRowsPerPage={(value: number) => {
                    // TODO: Implement pagination
                }}
                handlePageChange={(page: number) => {
                    // TODO: Implement pagination
                }}
            />
        </Paper>
    );
};
